document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".filter-button");
  const blogPosts = document.querySelectorAll(".blog-post");

  filterButtons.forEach(button => {
    // Only attach filtering logic to <button> elements
    if (button.tagName.toLowerCase() !== "button") return;

    button.addEventListener("click", function (event) {
      event.preventDefault(); // Only blocks <button>, not <a>

      const filterTag = this.getAttribute("data-tag").toLowerCase().trim().replace(/\s+/g, "-");
      console.log("Clicked Filter:", filterTag);

      filterButtons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");

      blogPosts.forEach(post => {
        let postTags = (post.getAttribute("data-tags") || "")
          .toLowerCase()
          .split(",")
          .map(tag => tag.trim().replace(/\s+/g, "-"));

        console.log("Post Tags:", postTags);

        if (filterTag === "all" || postTags.includes(filterTag)) {
          post.style.display = "block";
        } else {
          post.style.display = "none";
        }
      });
    });
  });
});

